export enum AccountType {
    None = 0,
    Ordinary = 1,
    Checking,
    Savings,
    Other,
}